import type {ItemStatePayload, ItemStateValue} from '../../types/types.ts';

const SEEN: ItemStateValue = 'seen';
const DONE: ItemStateValue = 'done';

const validStates = [SEEN, DONE];

export class ItemState {
	readonly #id;
	#state: ItemStateValue | undefined;
	#starred: boolean;
	#mobileProgress = 0;
	#desktopProgress = 0;

	constructor(data: ItemStatePayload) {
		this.#id = data.id;
		this.#state = data.state || undefined;
		this.#starred = data.starred || false;
		this.#mobileProgress = data.mobileProgress || 0;
		this.#desktopProgress = data.desktopProgress || 0;
	}

	get id() {
		return this.#id;
	}

	get state() {
		return this.#state;
	}

	get starred() {
		return this.#starred || false;
	}

	get mobileProgress() {
		return this.#mobileProgress || 0;
	}

	get desktopProgress() {
		return this.#desktopProgress || 0;
	}

	clearState() {
		this.#state = undefined;
	}

	setStarred(starred: boolean) {
		this.#starred = starred;
	}

	setMobileProgress(lastPageSeen: number) {
		this.#mobileProgress = lastPageSeen;
	}

	setDesktopProgress(lastePageSeen: number) {
		this.#desktopProgress = lastePageSeen;
	}

	setState(state: ItemStateValue) {
		if (state === 'deep-dive') {
			return;
		}
		if (!validStates.includes(state)) {
			throw new Error(`Invalid state "${state}". Valid states are: ${validStates.join(', ')}`);
		}

		this.#state = state;
	}

	toString() {
		return JSON.stringify({
			id: this.#id,
			state: this.#state,
			starred: this.#starred || false,
			desktopProgress: this.#desktopProgress,
			mobileProgress: this.#mobileProgress
		});
	}

	toObject(): ItemStatePayload {
		return {
			id: this.#id,
			state: this.#state,
			starred: this.#starred || false,
			desktopProgress: this.#desktopProgress,
			mobileProgress: this.#mobileProgress
		};
	}

	static fromString(string: string): ItemState {
		const data = JSON.parse(string);

		return new ItemState(data);
	}
}
